import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M3.413 1.974c.9-.972 2.327-.707 3.073.175l1.505 1.779c.616.727.717 1.76.254 2.593l-.446.804c-.183.329-.163.702.03.97.392.545.993 1.31 1.755 2.072a17.146 17.146 0 002.072 1.755c.268.193.64.213.97.03l.804-.446a2.292 2.292 0 012.593.253l1.779 1.506c.882.746 1.147 2.172.175 3.073-.569.526-1.308 1.063-2.155 1.346-1.103.367-2.46.151-3.97-.584-1.52-.74-3.27-2.043-5.214-3.987C4.693 11.37 3.39 9.62 2.65 8.1c-.736-1.51-.951-2.867-.584-3.97.283-.847.82-1.587 1.346-2.155z",
    fill: "#EE4D2D"
  }));
}
export default SvgComponent;